<template>
  <div v-if="hasServicePointEvent && itemData.externalTrackingLink">
    <h2 class="tracking-status-text regular">
      {{ t('deliveredToServicePoint') }}
    </h2>

    <div>
      <p class="text-black-50 mb-1">
        {{ t('shippingProvider') }}
      </p>
      <h4>
        {{ itemData.partnerName }}
      </h4>
    </div>

    <div>
      <p class="text-black-50 mb-1">
        {{ t('servicePointDetails') }}
      </p>
      <h4>
        <a class="green-link" :href="itemData.externalTrackingLink" target="_blank">{{
          itemData.externalTrackingLink
        }}</a>
      </h4>
    </div>

    <hr class="tracking-divider" />
  </div>
</template>

<script lang="ts">
import type { TrackingData, TrackingEvent } from '@/types/Models/Shipment'
import { computed, type ComputedRef, defineComponent, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'ExternalPartner',
  props: {
    itemData: {
      type: Object as PropType<TrackingData>,
      required: true,
    },
    events: {
      type: Array as PropType<TrackingEvent[]>,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const hasServicePointEvent: ComputedRef<boolean> = computed(() => {
      return props.events.some((e) => e.description === 'Available at pick-up point')
    })

    return {
      hasServicePointEvent,
      t,
    }
  },
})
</script>
